/** Shared modal dismissal lifecycle without importing React. */
export function attachModalEscapeDismissal({
  isOpen,
  onClose,
  dismissOnBackdrop = true,
  documentRef,
}) {
  if (!isOpen || !dismissOnBackdrop || !documentRef?.addEventListener) return undefined;

  const handleKeyDown = (event) => {
    if (event.key === "Escape") onClose?.();
  };

  documentRef.addEventListener("keydown", handleKeyDown);
  return () => documentRef.removeEventListener("keydown", handleKeyDown);
}

export function getModalBackdropClickHandler(onClose, dismissOnBackdrop = true) {
  return dismissOnBackdrop ? onClose : undefined;
}

